export default __webpack_public_path__ + "static/media/frontdesk-booking-view.ad9f73ba.webp";